<div>
    <fc-index *ngIf="dialogsService.isIndexOpen()" 
                class="index-container">
    </fc-index>
    <fc-search *ngIf="dialogsService.isSearchOpen()">
    </fc-search>
    <fc-licensee *ngIf="dialogsService.isLicenseeOpen()"></fc-licensee>
    <fc-error *ngIf="dialogsService.isErrorOpen()"></fc-error>
</div>
